import { render, staticRenderFns } from "./FacilityEditAddressPostal.vue?vue&type=template&id=a4a9dd8e&"
import script from "./FacilityEditAddressPostal.vue?vue&type=script&lang=js&"
export * from "./FacilityEditAddressPostal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports